import baseTheme from '../base'

const MuiFormControlLabel = {
  styleOverrides: {
    root: {
      marginLeft: 0,
    },
    label: {
      ...baseTheme.typography.body2,
    },
  },
}

export default MuiFormControlLabel
